import { CashReportDetailCategory } from '@spike/payments-model';

const CATEGORY_LABELS: Record<CashReportDetailCategory, string> = {
    service: 'Services',
    addon: 'Add-On Services',
    membership: 'Memberships',
    product: 'Products',
    custom: 'Custom Items',
    refund: 'Refunds'
};

const PAYMENT_TYPE_LABELS: Record<string, string> = {
    cash: 'Cash',
    credit_card: 'Credit Card',
    card_on_file: 'Card on File',
    pos: 'POS',
    pay_by_link: 'Pay By Link',
    wallet: 'Wallet',
    other: 'Other'
};

export const categoryLabel = (category: CashReportDetailCategory) => CATEGORY_LABELS[category];

export const paymentTypeLabel = (paymentType: string) =>
    PAYMENT_TYPE_LABELS[paymentType] ?? paymentType.replace(/_/g, ' ').replace(/^\w/, letter => letter.toUpperCase());
